export default "__VITE_ASSET__Bub2nDl$__"